import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * SinceLastVisit — bandeau "hook" affiché tout en haut du dashboard.
 *
 * N'apparaît QUE s'il y a une bonne nouvelle depuis la dernière visite
 * (nouveaux avis, note en hausse, nouveaux scans). Son apparition = signal
 * positif → meilleur déclencheur de retour qu'un bandeau permanent qui
 * répèterait "rien de neuf".
 *
 * data (depuis GET /api/dashboard/ → since_last_visit) :
 *   { days_since, new_avis, new_scans, note_current, note_delta, has_news }
 *   = null à la 1ère visite (rien à comparer).
 */
export default function SinceLastVisit({ data }) {
  const { t, i18n } = useTranslation('dashboard');
  if (!data || !data.has_news) return null;

  const fmt = (x) =>
    new Intl.NumberFormat(i18n.language, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(x);

  const parts = [];
  if (data.new_avis > 0) parts.push(t(data.new_avis === 1 ? 'v2.slv_avis_one' : 'v2.slv_avis_other', { count: data.new_avis }));
  if (data.note_delta > 0) {
    parts.push(t('v2.slv_note', { note: fmt(data.note_current), delta: fmt(data.note_delta) }));
  }
  if (data.new_scans > 0) parts.push(t(data.new_scans === 1 ? 'v2.slv_scans_one' : 'v2.slv_scans_other', { count: data.new_scans }));
  if (parts.length === 0) return null;

  const when = data.days_since <= 0 ? t('v2.slv_today') : t('v2.slv_days_ago', { count: data.days_since });

  return (
    <div
      id="since-last-visit"
      style={{
        gridColumn: '1 / -1',
        background: 'linear-gradient(90deg, #FFF7ED 0%, #FFFBF5 100%)',
        border: '1px solid #F5DBA0',
        borderRadius: 14,
        padding: '13px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 14,
        color: '#7A4A12',
        flexWrap: 'wrap',
        lineHeight: 1.4,
      }}
    >
      <span style={{ fontWeight: 700 }}>
        👋 {t('v2.slv_title')}{' '}
        <span style={{ fontWeight: 400, opacity: 0.65 }}>({when})</span>
      </span>
      <span style={{ fontWeight: 600 }}>{parts.join('  ·  ')}</span>
    </div>
  );
}
